import Block from './Block'

export default class ProductGallery extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.currentIndex = 0;
  }

  getElems() {
    super.getElems()

    this.$cover = this.el.querySelectorAll('.single-product__cover .image')
    this.$image = this.el.querySelectorAll('.single-product__images .image')
  }

  events() {
    super.events()

    for (let i = 0; i < this.$image.length; i++) {
      this.$image[i].addEventListener('click', this.toggle.bind(this, i))
    }
  }

  toggle(i) {
    if (i !== this.currentIndex) {
      this.$cover[this.currentIndex].style.opacity = 0
      this.$cover[i].style.opacity = 1
      this.currentIndex = i
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/ProductGallery.js